import React from 'react';
import styles from './Trainings.css.js';
import FadeIn from 'react-fade-in';
import { Parallax } from 'react-parallax';

export default function TrainingsDesktop() {
    return (
        <div className='trainingsContainer' style={styles.trainingsContainer}>
             <div className='trainingsCopy' style={styles.trainingsCopy}>
             <FadeIn delay='2000' transitionDuration='2000' >
                <h1 style={styles.head}>Training</h1>
                <ul>
                    <li style={styles.item}> Continuing Education </li>
                    <li style={styles.item}> Diversity </li>
                    <li style={styles.item}> Self-care </li>
                    <li style={styles.item}> Risk Management  </li>
                    <li style={styles.item}> Professional Development </li>
                    <li style={styles.item} id='psychotherapy'> Evidence-based Treatment</li>
                </ul>
                </FadeIn>
             </div>
             <Parallax
            //blur={10}
            bgImage={require('../../../resources/trainingsImg.jpg')}
            bgImageAlt="splash"
            strength={175}
            >
             <div className='trainingsImage' style={styles.trainingsImage}>

             </div>
             </Parallax>
        </div>
    )
}
